<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-supervision-activity-header
                    >Simulacros /
                    Capacitaciones</app-supervision-activity-header
                >
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-internal-management-form
                    :selected-client="supervisionClient"
                    :types="managementTypes"
                    :on-save="onSave"
                    :venues="venues"
                ></app-internal-management-form>
            </b-col>
        </b-row>
        <b-row class="justify-content-end mt-3">
            <b-col cols="12" md="3">
                <b-btn
                    variant="confirm"
                    block
                    @click="saveManagement"
                    :disabled="inProgress"
                    ><i class="fa fa-save"></i> Guardar</b-btn
                >
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import appInternalManagementForm from '../../Reporting/Company/InternalManagement/InternalManagementForm/InternalManagementForm'
import { mapGetters } from 'vuex'
import internalManagementRepository from '@repositories/internalManagement.repository'
import appSupervisionActivityHeader from '../SupervisionActivityHeader'
export default {
    components: {
        appInternalManagementForm,
        appSupervisionActivityHeader,
    },
    data: () => ({
        types: [],
        venues: [],
    }),
    computed: {
        ...mapGetters(['supervisionClient']),
        managementTypes() {
            return this.types
        },
    },
    methods: {
        loadInternalManagementTypes() {
            const ir = { ...internalManagementRepository }
            ir.getTypes()
                .then(data => (this.types = data))
                .catch(error =>
                    toastr.error(
                        'Ocurrió un error al cargar los tipos de gestión interna'
                    )
                )
        },
        onSave() {
            this.$router.push({ name: 'supervisionIndexPage' })
        },
        saveManagement() {
            this.$bus.$emit('internal-management-form.save')
        },
        async loadVenues() {
            const { data } = await repo.get('venues', {
                client: this.supervisionClient.id,
            })
            this.venues = data
        },
    },
    created() {
        this.loadInternalManagementTypes()
        this.loadVenues()
    },
}
</script>
